import { render, staticRenderFns } from "./uptos3-videos.vue?vue&type=template&id=07ce0fd1&scoped=true&"
import script from "./uptos3-videos.vue?vue&type=script&lang=js&"
export * from "./uptos3-videos.vue?vue&type=script&lang=js&"
import style0 from "./uptos3-videos.vue?vue&type=style&index=0&id=07ce0fd1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ce0fd1",
  null
  
)

export default component.exports